import { useMediaQuery } from '@mui/material'
import theme from '../theme'

export const MOBILE_QUERY = theme.breakpoints.down('sm')

export const useIsMobile = (): boolean => {
    return useMediaQuery(MOBILE_QUERY)
}
